var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwIconSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15060",
    "data-name": "Group 15060",
    transform: "translate(-0.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3476",
    "data-name": "Rectangle 3476",
    width: 28,
    height: 28,
    transform: "translate(0.362)",
    fill: "#0b66c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M17.014,7.219c.012.168.012.337.012.505A10.982,10.982,0,0,1,5.968,18.782,10.983,10.983,0,0,1,0,17.038a8.04,8.04,0,0,0,.939.048,7.783,7.783,0,0,0,4.825-1.66,3.893,3.893,0,0,1-3.634-2.7,4.9,4.9,0,0,0,.734.06,4.11,4.11,0,0,0,1.023-.132A3.887,3.887,0,0,1,.77,8.843V8.8a3.914,3.914,0,0,0,1.757.493,3.892,3.892,0,0,1-1.2-5.2A11.047,11.047,0,0,0,9.337,8.158a4.387,4.387,0,0,1-.1-.89,3.89,3.89,0,0,1,6.726-2.659,7.652,7.652,0,0,0,2.467-.939,3.876,3.876,0,0,1-1.709,2.142,7.791,7.791,0,0,0,2.238-.6,8.354,8.354,0,0,1-1.949,2.009Z",
    transform: "translate(4.699 3.616)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwIconSm);
export default __webpack_public_path__ + "static/media/tw-icon-sm.0b25c26dd5b9ab9422a63d54a8ee1bc5.svg";
export { ForwardRef as ReactComponent };